import { useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { useExerciseInDisguiseContentViewCreator } from '@viewCreators';
import { ToDateTime } from '@utils/DateUtils';

export const useExerciseInDisguiseController = (groupStart: string | DateTime) => {
  const DAY_8 = 8;
  const emptyContent = { title: '', body: '', offset: 0, duration: 0 };
  const message = 'Stay consistent, and this feature will unlock as you progress.';
  const [open, setOpen] = useState(false);
  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const groupStartDate = groupStart ? ToDateTime(groupStart) : undefined;
  const { data } = useExerciseInDisguiseContentViewCreator(groupStartDate);

  const enabled = useMemo(() => {
    if (!groupStartDate) return false;
    // Round up, as PotCard does. `diffNow` on a cohort that is on day 8 returns
    // ~7.4 — it started 7 days ago — so comparing the raw value against DAY_8 held
    // the card back until day 9.
    const daysFromStart = Math.abs(groupStartDate.diffNow('days').days);
    return Math.ceil(daysFromStart) >= DAY_8;
  }, [groupStart]);

  const learnMoreDisabled = useMemo(() => {
    if (!groupStartDate) return true;
    if (!data) return false;
    return !enabled;
  }, [data, groupStart]);

  return {
    enabled,
    disabledMessage: message,
    content: { ...(data?.content || emptyContent) },
    openDialog,
    closeDialog,
    dialogOpen: open,
    learnMoreDisabled,
  };
};
